// extracted by mini-css-extract-plugin
export var content = "text-image-dr-module--content--20f81";
export var image = "text-image-dr-module--image--fbe28";
export var left = "text-image-dr-module--left--f995c";
export var right = "text-image-dr-module--right--dab56";
export var textImage = "text-image-dr-module--text-image--0e2ac";
export var youtube = "text-image-dr-module--youtube--a6ce0";